<template>
	<div class="page">
		<top-header></top-header>
		<b-container fluid>
			<b-row class="mt-3 mb-2">
				<b-col cols="4">
					<b-img :src="$session.get('weburl')+'/images/'+$session.get('user_info').permissions.logo_left" v-if="$session.get('user_info').permissions.logo_left!=''" fluid alt="Fluid image" style="max-width:100px;" class="my-2"></b-img>
				</b-col>
				<b-col cols="4" class="text-center">
					<b-img :src="$session.get('weburl')+'/logos/'+$route.params.ulbareacode+'.png'" style="max-height:80px"></b-img>
					<h4 class="text-uppercase"><b>{{zoneinfo.title}}</b></h4>
				</b-col>
				<b-col cols="4" class="text-right">
					<b-img :src="$session.get('weburl')+'/images/'+$session.get('user_info').permissions.logo_right" fluid alt="EESL" style="max-width:100px;" class="mr-2"></b-img>
					<b-button variant="dark" pill class="mr-2" v-if="$root.chkperm('page_devices','add')" @click="showAddModal()">Add CCMS</b-button>
					<b-button variant="dark" pill class="" v-if="$root.chkperm('page_devices','export')"  @click="downloadcsv()">Export</b-button>
				</b-col>
			</b-row>
		</b-container>
		<b-container fluid>
			<b-row class="px-2">
				<b-col class="px-2">
					<b-card img-src="../assets/dcu.svg" img-alt="Card image" img-left class="info-box mb-3">
						<h6>Total CCMS</h6>
						<b-card-text>
							{{records.length}}
						</b-card-text>
					</b-card>
				</b-col>
				<b-col class="px-2">
					<b-card img-src="../assets/dcu.svg" img-alt="Card image" img-left class="info-box mb-3">
						<h6>CCMS Connected</h6>
						<b-card-text>
							{{ device_connected }} <small>Nos</small>
						</b-card-text>
					</b-card>
					
				</b-col>
				<b-col class="px-2">
					<b-card img-src="../assets/dcu.svg" img-alt="Card image" img-left class="info-box mb-3 bg-orange">
						<h6>Temp. Signal Loss (CCMS)</h6>
						<b-card-text>
							{{ records.length - device_connected }} <small>Nos</small>
						</b-card-text>
					</b-card>
				</b-col>
				<b-col class="px-2">
					<b-card img-src="../assets/dcu.svg" img-alt="Card image" img-left class="info-box mb-3 bg-green">
						<h6>CCMS ON</h6>
						<b-card-text>
							{{ device_on }} <small>Nos</small>
						</b-card-text>
					</b-card>
					
				</b-col>
				<b-col class="px-2">
					<b-card img-src="../assets/dcu.svg" img-alt="Card image" img-left class="info-box mb-3 bg-red">
						<h6>CCMS OFF</h6>
						<b-card-text>
							{{ device_connected - device_on}} <small>Nos</small>
						</b-card-text>
					</b-card>
				</b-col>
				<!--<b-col>
					<b-card img-src="../assets/electric.svg" img-alt="Card image" img-left class="info-box mb-3">
						<h6>Total Load</h6>
						<b-card-text>
							{{ $root.tofixed(total_load / 1000 , 3) }} <small>KW</small>
						</b-card-text>
					</b-card>
				</b-col>
				<b-col>
					<b-card img-src="../assets/electric.svg" img-alt="Card image" img-left class="info-box mb-3">
						<h6>Current Load</h6>
						<b-card-text>
							{{current_load/100000}} <small>KW</small>
						</b-card-text>
					</b-card>
				</b-col>-->
			</b-row>
			<b-row class="px-2">
				<b-col class="px-2">
					<b-card img-src="../assets/street-light.svg" img-alt="Card image" img-left class="info-box mb-3">
						<h6>Total Lights</h6>
						<b-card-text>
							{{total_lights}}
						</b-card-text>
					</b-card>
				</b-col>
				<b-col class="px-2">
					<b-card img-src="../assets/light-on.svg" img-alt="Card image" img-left class="info-box mb-3 bg-green">
						<h6>Total Light ON</h6>
						<b-card-text>
							{{total_light_on}} <small>({{ $root.tofixed((total_light_on/total_lights)*100, 2) }}%)</small>
						</b-card-text>
					</b-card>
				</b-col>
				<b-col class="px-2">
					<b-card img-src="../assets/light-off.svg" img-alt="Card image" img-left class="info-box mb-3 bg-red">
						<h6>Total Light OFF</h6>
						<b-card-text>
							{{total_light_off}} <small>({{ $root.tofixed((total_light_off/total_lights)*100, 2) }}%)</small>
						</b-card-text>
					</b-card>
				</b-col>
				<b-col class="px-2">
					<b-card img-src="../assets/no-light.svg" img-alt="Card image" img-left class="info-box mb-3 bg-orange">
						<h6>Temp. Signal Loss (Light)</h6>
						<b-card-text>
							{{total_signal_loss}} <small>({{ $root.tofixed((total_signal_loss/total_lights)*100, 2) }}%)</small>
						</b-card-text>
					</b-card>
				</b-col>
				<b-col class="px-2">
					<b-card img-src="../assets/electric.svg" img-alt="Card image" img-left class="info-box mb-3">
						<h6>Total Consumption</h6>
						<b-card-text>
							{{$root.tofixed(total_kwh/100, 2)}} <small>KWH</small>
						</b-card-text>
					</b-card>
				</b-col>
			</b-row>
			<b-row class="px-2">
				
				<b-col class="px-2">
					<b-card img-src="../assets/electric.svg" img-alt="Card image" img-left class="info-box mb-3">
						<h6>Total Load</h6>
						<b-card-text>
							{{ $root.tofixed(total_load / 1000 , 3) }} <small>KW</small>
						</b-card-text>
					</b-card>
				</b-col>
				<b-col class="px-2">
					<b-card img-src="../assets/electric.svg" img-alt="Card image" img-left class="info-box mb-3">
						<h6>Current Load</h6>
						<b-card-text>
							{{current_load/100000}} <small>KW</small>
						</b-card-text>
					</b-card>
				</b-col>
				<b-col class="px-2">
					<b-card img-src="../assets/green-energy.svg" img-alt="Card image" img-left class="info-box mb-3">
						<h6>Energy Saving Per Year</h6>
						<b-card-text><!-- (75/1000) = 1 unit -->
							<!--{{ $root.tofixed((11 * 30 * 12 * (75/1000) * total_lights)/10000, 3) }} <small>MU</small>-->
							{{ $root.tofixed((12 * 365 * (zoneinfo.previous_load - (total_load/1000)))/1000000, 3) }} <small>MU</small>
						</b-card-text>
					</b-card>
				</b-col>
				<b-col class="px-2">
					<b-card img-src="../assets/save-money.svg" img-alt="Card image" img-left class="info-box mb-3">
						<h6>Revenue Saving Per Year</h6>
						<b-card-text><!-- (75/1000) = 1 unit -->
							₹ {{  $root.tofixed((12 * 365 * (zoneinfo.previous_load - (total_load/1000)))/10000000 * zoneinfo.tariff_rate, 2) }} <small>Crores</small>
						</b-card-text>
					</b-card>
				</b-col>
				<b-col class="px-2">
					<b-card img-src="../assets/save-money.svg" img-alt="Card image" img-left class="info-box mb-3">
						<h6>CO2 Reduction Per Year</h6>
						<b-card-text><!-- (75/1000) = 1 unit -->
							{{  $root.tofixed((12 * 365 * (zoneinfo.previous_load - (total_load/1000)))/1000000 * 0.82, 2)  }} <small>Million Tons</small>
						</b-card-text>
					</b-card>
				</b-col>
			</b-row>
			<b-row>
				<b-col class="col-md-5 col-sm-5 col-xs-5">
					<h6><b><i>SCHEDULE TIMING:&nbsp;&nbsp;</i> <span style="font-size:13px; padding-left:10px;">ON TIME:</span> <b-badge pill variant="info">{{zoneinfo.on_time}}</b-badge> <span style="font-size:13px; padding-left:10px;">OFF TIME:</span> <b-badge pill variant="info">{{zoneinfo.off_time}}</b-badge></b></h6>
				</b-col>
				<b-col class="col-md-7 col-sm-7 col-xs-7">
					<h6><b><span style="font-size:13px; padding-left:10px;">POWER CUT:</span> <b-badge pill variant="danger">{{total_power_cut}}</b-badge> <span style="font-size:13px; padding-left:10px;">OVERLOAD:</span> <b-badge pill variant="danger">{{total_overload}}</b-badge></b></h6>
				</b-col>
			</b-row>
			<b-row>
				<b-col class="col-md-12 col-sm-12 col-xs-12">
					<div class="container-box">
						<b-row class="mt-4 px-3">
							<b-col lg="4">
								<span class="mr-2">Show</span>
								<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
								</b-form-select>
								<span class="ml-2">entries</span>
							</b-col>
							<b-col lg="4">
								<span class="mr-2">Network Filter</span>
								<b-form-select v-model="networkfilter" :options="networkOptions" size="sm" class="w-25" @change="powerfilter=-1; onFilterDevices()">
								</b-form-select>
								<span class="ml-4 mr-2">Power Filter</span>
								<b-form-select v-model="powerfilter" :options="powerOptions" size="sm" class="w-25" @change="networkfilter=-1; onFilterDevices()">
								</b-form-select>
							</b-col>
							<b-col lg="4">
								<b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0">
									<b-input-group size="sm">
										<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
										</b-form-input>
										<b-input-group-append>
											<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
										</b-input-group-append>
									</b-input-group>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row class="px-3 pt-3">
							<b-col lg="12">
								<b-table show-empty sticky-header small striped outlined id="my-table" stacked="md" :items="filteredrecords" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">
									<template v-slot:cell(FITTINGS)="row">
										<b-badge :id="'F'+row.item.IMEI_NO" pill variant="success">{{row.item.FITTINGS}}</b-badge>
										<b-popover
											:target="`F${row.item.IMEI_NO}`"
											title="Total Fittings!"
											triggers="hover focus">
											<b-row v-if="row.item.LED_18">
												<b-col><b-badge pill variant="light" class="pb-1">18 w</b-badge> X <b-badge pill variant="info" class="pb-1">{{row.item.LED_18}}</b-badge> = <b-badge pill variant="primary" class="pb-1">{{18 * row.item.LED_18}} w</b-badge></b-col>
											</b-row>
											<b-row v-if="row.item.LED_24">
												<b-col><b-badge pill variant="light" class="pb-1">24 w</b-badge> X <b-badge pill variant="info" class="pb-1">{{row.item.LED_24}}</b-badge> = <b-badge pill variant="primary" class="pb-1">{{24 * row.item.LED_24}} w</b-badge></b-col>
											</b-row>
											<b-row v-if="row.item.LED_35">
												<b-col><b-badge pill variant="light" class="pb-1">35 w</b-badge> X <b-badge pill variant="info" class="pb-1">{{row.item.LED_35}}</b-badge> = <b-badge pill variant="primary" class="pb-1">{{35 * row.item.LED_35}} w</b-badge></b-col>
											</b-row>
											<b-row v-if="row.item.LED_45">
												<b-col><b-badge pill variant="light" class="pb-1">45 w</b-badge> X <b-badge pill variant="info" class="pb-1">{{row.item.LED_45}}</b-badge> = <b-badge pill variant="primary" class="pb-1">{{45 * row.item.LED_45}} w</b-badge></b-col>
											</b-row>
											<b-row v-if="row.item.LED_60">
												<b-col><b-badge pill variant="light" class="pb-1">60 w</b-badge> X <b-badge pill variant="info" class="pb-1">{{row.item.LED_60}}</b-badge> = <b-badge pill variant="primary" class="pb-1">{{60 * row.item.LED_60}} w</b-badge></b-col>
											</b-row>
											<b-row v-if="row.item.LED_70">
												<b-col><b-badge pill variant="light" class="pb-1">70 w</b-badge> X <b-badge pill variant="info" class="pb-1">{{row.item.LED_70}}</b-badge> = <b-badge pill variant="primary" class="pb-1">{{70 * row.item.LED_70}} w</b-badge></b-col>
											</b-row>
											<b-row v-if="row.item.LED_75">
												<b-col><b-badge pill variant="light" class="pb-1">75 w</b-badge> X <b-badge pill variant="info" class="pb-1">{{row.item.LED_75}}</b-badge> = <b-badge pill variant="primary" class="pb-1">{{75 * row.item.LED_75}} w</b-badge></b-col>
											</b-row>
											<b-row v-if="row.item.LED_80">
												<b-col><b-badge pill variant="light" class="pb-1">80 w</b-badge> X <b-badge pill variant="info" class="pb-1">{{row.item.LED_80}}</b-badge> = <b-badge pill variant="primary" class="pb-1">{{80 * row.item.LED_80}} w</b-badge></b-col>
											</b-row>
											<b-row v-if="row.item.LED_110">
												<b-col><b-badge pill variant="light" class="pb-1">110 w</b-badge> X <b-badge pill variant="info" class="pb-1">{{row.item.LED_110}}</b-badge> = <b-badge pill variant="primary" class="pb-1">{{110 * row.item.LED_110}} w</b-badge></b-col>
											</b-row>
											<b-row v-if="row.item.LED_130">
												<b-col><b-badge pill variant="light" class="pb-1">130 w</b-badge> X <b-badge pill variant="info" class="pb-1">{{row.item.LED_130}}</b-badge> = <b-badge pill variant="primary" class="pb-1">{{130 * row.item.LED_130}} w</b-badge></b-col>
											</b-row>
											<b-row v-if="row.item.LED_140">
												<b-col><b-badge pill variant="light" class="pb-1">140 w</b-badge> X <b-badge pill variant="info" class="pb-1">{{row.item.LED_140}}</b-badge> = <b-badge pill variant="primary" class="pb-1">{{140 * row.item.LED_140}} w</b-badge></b-col>
											</b-row>
											<b-row v-if="row.item.LED_190">
												<b-col><b-badge pill variant="light" class="pb-1">190 w</b-badge> X <b-badge pill variant="info" class="pb-1">{{row.item.LED_190}}</b-badge> = <b-badge pill variant="primary" class="pb-1">{{190 * row.item.LED_190}} w</b-badge></b-col>
											</b-row>
											<b-row v-if="row.item.LED_200">
												<b-col><b-badge pill variant="light" class="pb-1">200 w</b-badge> X <b-badge pill variant="info" class="pb-1">{{row.item.LED_200}}</b-badge> = <b-badge pill variant="primary" class="pb-1">{{200 * row.item.LED_200}} w</b-badge></b-col>
											</b-row>
										</b-popover>
									</template>
									<template v-slot:cell(maintenance)="row">
										<b-badge pill variant="warning" v-if="row.value == 1">YES</b-badge>
										<b-badge pill variant="secondary" v-else>NO</b-badge>
									</template>
									<template v-slot:cell(DOOR_STATUS)="row">
										<b-badge pill variant="danger" v-if="row.value == 1">OPENED</b-badge>
										<b-badge pill variant="success" v-else>CLOSED</b-badge>
									</template>
									<template v-slot:cell(fault)="row">
										<b-badge pill variant="danger" v-if="(row.value > 100)">{{row.value}} %</b-badge>
										<b-badge pill variant="warning" v-else-if="(row.item.OUTPUT_STATUS == 1 && row.value == 0 )">{{row.value}} %</b-badge>
										<b-badge pill variant="success" v-else>{{row.value}} %</b-badge>
									</template>
									<template v-slot:cell(overload)="row">
										<b-badge pill variant="danger" v-if="(row.value > 0)">{{row.value}} %</b-badge>
									</template>
									<template v-slot:cell(underload)="row">
										<b-badge pill variant="primary" v-if="(row.value > 0)">{{row.value}} %</b-badge>
									</template>
									<template v-slot:cell(supply)="row">
										<img src="../assets/power-on.svg" v-if="row.value == '1'" style="max-width:20px; max-height:20px;">
										<img src="../assets/power-off.svg" v-else style="max-width:20px; max-height:20px;">
									</template>
									<template v-slot:cell(OUTPUT_STATUS)="row">
										<b-badge pill variant="success" v-if="(row.value == 1)">ON</b-badge>
										<b-badge pill variant="danger" v-else>OFF</b-badge>
									</template>
									<template v-slot:cell(sys_meter_no)="row">
										<img src="../assets/meter-error.svg" v-if="row.value == 1" style="max-width:14px; max-height:14px;">
										<img src="../assets/meter-ok.svg" v-else style="max-width:14px; max-height:14px;">
									</template>
									<template v-slot:cell(FP_NO)="row">
										<b-link :href="'/device-data/'+row.item.IMEI_NO">{{row.value}}</b-link>
									</template>
									<template v-slot:cell(connection_status)="row">
										<b-link :href="'/device-fault/'+row.item.IMEI_NO" v-if="row.value == 2"><div><b-badge pill variant="warning">METER FAULT</b-badge></div></b-link>
										<b-badge pill variant="danger" v-else-if="row.value == 0">DISCONNECTED</b-badge>
										<b-badge pill variant="warning" v-else-if="row.value == 3">DATA FAULT</b-badge>
										<b-badge pill variant="success" v-else>CONNECTED</b-badge>
									</template>
								</b-table>
							</b-col>
						</b-row>
						<b-row class="px-3">
							<b-col lg="6">
								<span class="mr-2">Showing {{currentPage}} to {{(perPage>filteredrecords.length)?filteredrecords.length:perPage}} of {{filteredrecords.length}} entries</span>
							</b-col>
							<b-col lg="3" offset-md="3">
								<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
			<b-container fluid style="display:none">
				<b-row class="my-3">
					<b-col md="12">
						<line-chart ref="livechart"/>
					</b-col>
				</b-row>
			</b-container>
			<b-row class="my-3">
				<b-col>
					<div class="float-left">
						<img src="../assets/flag-green.png" style="width: 20px; max-height:28px;"/>
						<span class="pl-2 text-sm"><b>DEVICE ON</b></span>
					</div>
					<div class="float-left ml-5">
						<img src="../assets/flag-red.png" style="width: 20px; max-height:28px;"/>
						<span class="pl-2 text-sm"><b>DEVICE OFF</b></span>
					</div>
					<div class="float-left ml-5">
						<img src="../assets/flag-blue.png" style="width: 20px; max-height:28px;"/>
						<span class="pl-2 text-sm"><b>TEMPORARY SIGNAL LOSS</b></span>
					</div>
				</b-col>
				<b-col cols="6">
					<span class="float-right text-sm pt-2"><b>LAST SYNC TIME: {{last_sync_time}}</b></span>
				</b-col>
			</b-row>
			<b-row class="my-3">
				<b-col>
					<gmap-map :center="center" :zoom="zoneinfo.zoom" class="googlemap">
						<gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWindowOpen" @closeclick="infoWindowOpen=false"></gmap-info-window>
						<gmap-marker :key="index" v-for="(m, index) in markers" :position="m.position" :clickable="true" :icon="m.icon" @click="toogleMarkerInfoWindow(m,index)"></gmap-marker>
					</gmap-map>
				</b-col>
			</b-row>
			<b-modal id="view-model" title="View DCU" ok-only @hide="setMaintenance">
				<b-container fluid>
					<b-row class="mb-1r">
						<b-col cols="4" class="text-right">IMEI :</b-col>
						<b-col cols="8">{{selectedItem.imei_no}}</b-col>
					</b-row>
					<b-row class="mb-1r">
						<b-col cols="4" class="text-right">Zone :</b-col>
						<b-col cols="8">{{selectedItem.ulb_id}}</b-col>
					</b-row>
					<b-row class="mb-1r">
						<b-col cols="4" class="text-right">Feeder Pillor No :</b-col>
						<b-col cols="8">{{selectedItem.feeder_pillar_no}}</b-col>
					</b-row>
					<b-row class="mb-1r">
						<b-col cols="4" class="text-right">Ward No :</b-col>
						<b-col cols="8">{{selectedItem.ward_no}}</b-col>
					</b-row>
				</b-container>
				<template v-slot:modal-footer="{ ok, close, hide }">
					<div v-if="$root.chkperm('page_devices','maintenance')">
						<b-button size="sm" variant="warning" v-if="selectedItem.maintenance == 0" @click="hide('maintenance_on')">Maintenance ON</b-button>
						<b-button size="sm" variant="warning" v-else @click="hide('maintenance_off')">Maintenance OFF</b-button>
					</div>
					<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
					<b-button size="sm" variant="success" @click="ok()">Ok</b-button>
				</template>
			</b-modal>

			<b-modal id="replace-model" title="Replace Panel" size="lg" ok-only @hidden="resetSelectedItem" @ok="onReplaceDevice">
				<b-container fluid>
					<b-row class="mb-1">
						<b-col>
							<b-alert show variant="secondary" class="header-title">Device Information</b-alert>
							<b-form-group label="Imei" label-for="imei-input" label-cols="4" label-size="sm" label-align-sm="right" invalid-feedback="Imei is required">
								<b-form-input id="imei-input" v-model="replaceItem.replace_imei_no" disabled></b-form-input>
							</b-form-group>
							<b-form-group label="Feeder Piller No" label-for="fp-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="fp-input" v-model="replaceItem.feeder_pillar_no" disabled></b-form-input>
							</b-form-group>
							<b-form-group label="Meter No" label-for="ccms-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="ccms-input" v-model="replaceItem.replace_meter_no" disabled></b-form-input>
							</b-form-group>
							<b-form-group label="Mobile No" label-for="ccms-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="mobile-input" v-model="replaceItem.mobile_no" disabled></b-form-input>
							</b-form-group>
						</b-col>
						<b-col>
							<b-alert show variant="secondary" class="header-title">Replace Information</b-alert>
							<b-form-group label="New CCMS" label-for="fp-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="location-input" v-model="replaceItem.new_imei_no" placeholder="New Imei no."></b-form-input>
							</b-form-group>
							<b-form-group label="New Meter" label-for="ward-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="location-input" v-model="replaceItem.new_meter_no" placeholder="New Meter no."></b-form-input>
							</b-form-group>
							<b-form-group label="Replace Date" label-for="ward-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-datepicker id="ward-input" v-model="replaceItem.replace_time" :date-format-options="{ year: 'numeric', month: 'long', day: '2-digit' }" required></b-form-datepicker>
							</b-form-group>
						</b-col>
					</b-row>
				</b-container>
				<form ref="form" @submit.stop.prevent="handleSubmit">
					
				</form>
				<template v-slot:modal-footer="{ ok, close }">
					<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
					<b-button size="sm" variant="success" @click="ok()">{{(selectedItem.id > 0)?'Update':'Submit'}}</b-button>
				</template>
			</b-modal>
			
			<b-modal id="edit-model" :title="(selectedItem.id > 0)?'Edit CCMS | DCU':'Add CCMS | DCU'" size="xl" ok-only @hidden="resetSelectedItem" @ok="modalSubmit">
				<b-container fluid>
					<b-row class="mb-1">
						<b-col>
							<b-alert show variant="secondary" class="header-title">Device Information</b-alert>
							<b-form-group label="Imei" label-for="imei-input" label-cols="4" label-size="sm" label-align-sm="right" invalid-feedback="Imei is required">
								<b-form-input id="imei-input" v-model="selectedItem.imei_no" :disabled="selectedItem.id > 0" required></b-form-input>
							</b-form-group>
							<b-form-group label="Feeder Piller No" label-for="fp-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="fp-input" v-model="selectedItem.feeder_pillar_no" :disabled="selectedItem.id > 0" required></b-form-input>
							</b-form-group>
							<b-form-group label="Device Type" label-for="title" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-select v-model="selectedItem.device_type">
									<b-form-select-option value="CCMS">CCMS</b-form-select-option>
									<b-form-select-option value="DCU">DCU</b-form-select-option>
								</b-form-select>
							</b-form-group>
							<b-form-group label="Meter Type" label-for="title" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-select v-model="selectedItem.meter_type">
									<b-form-select-option value="3P">3 Phase</b-form-select-option>
									<b-form-select-option value="1P">1 Phase</b-form-select-option>
								</b-form-select>
							</b-form-group>
							<b-form-group label="Meter No" label-for="ccms-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="ccms-input" v-model="selectedItem.device_no" :disabled="selectedItem.id > 0" required></b-form-input>
							</b-form-group>
							<b-form-group label="Mobile No" label-for="ccms-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="mobile-input" v-model="selectedItem.mobile_no" required></b-form-input>
							</b-form-group>
							<b-alert show variant="secondary" class="header-title">Map Information</b-alert>
							<b-form-group label="Latitude" label-for="load-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="load-input" v-model="selectedItem.location_lat" required></b-form-input>
							</b-form-group>
							<b-form-group label="Longitude" label-for="poles-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="poles-input" v-model="selectedItem.location_lng" required></b-form-input>
							</b-form-group>
						</b-col>
						<b-col>
							<b-alert show variant="secondary" class="header-title">Location Information</b-alert>
							<b-form-group label="State" label-for="fp-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-select v-model="selectedItem.state_id" :options="$root.state_options" @change="selectedItem.zone_id=0; selectedItem.ulb_id=0" required></b-form-select>
							</b-form-group>
							<b-form-group label="Zone" label-for="title" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-select v-model="selectedItem.zone_id">
									<b-form-select-option value="0">--- Select Zone ---</b-form-select-option>
									<b-form-select-option v-for="item in filterZone(zoneOptions)" v-bind:key="item.id" :value="item.id" @change="selectedItem.ulb_id=0">{{item.title}}</b-form-select-option>
								</b-form-select>
							</b-form-group>
							<b-form-group label="ULB" label-for="title" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-select v-model="selectedItem.ulb_id">
									<b-form-select-option value="0">--- Select ULB ---</b-form-select-option>
									<b-form-select-option v-for="item in filterULB(zoneOptions)" v-bind:key="item.id" :value="item.id" >{{item.title}}</b-form-select-option>
								</b-form-select>
							</b-form-group>
							<b-form-group label="Location" label-for="ward-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="location-input" v-model="selectedItem.location" required></b-form-input>
							</b-form-group>
							<b-form-group label="Ward No" label-for="ward-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="ward-input" v-model="selectedItem.ward_no" required></b-form-input>
							</b-form-group>
							<b-form-group label="Previous Load" label-for="prev-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="prevload-input" v-model="selectedItem.previous_load" required></b-form-input>
							</b-form-group>
							<b-form-group label="Total Load" label-for="load-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="load-input" v-model="selectedItem.total_load" required></b-form-input>
							</b-form-group>
							<!--<b-form-group label="Total Connection" v-if="selectedItem.device_type === 'CCMS'" label-for="poles-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="poles-input" v-model="selectedItem.total_connection" required></b-form-input>
							</b-form-group>-->
							<b-form-group label="No of Fittings" label-for="fitting-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="fitting-input" v-model="selectedItem.no_of_fittings" required></b-form-input>
							</b-form-group>
						</b-col>
						<b-col>
							<b-alert show variant="secondary" class="header-title">LED Information</b-alert>
							<b-row>
								<b-col class="pr-0">
									<b-form-group label="18W" label-cols="6" label-size="sm" label-align-sm="right">
										<b-form-input v-model="selectedItem.led_18w" @change="updateTotalLoad"></b-form-input>
									</b-form-group>
								</b-col>
								<b-col class="pl-0">
									<b-form-group label="24W" label-cols="6" label-size="sm" label-align-sm="right">
										<b-form-input v-model="selectedItem.led_24w" @change="updateTotalLoad"></b-form-input>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row>
								<b-col class="pr-0">
									<b-form-group label="35W" label-cols="6" label-size="sm" label-align-sm="right">
										<b-form-input v-model="selectedItem.led_35w" @change="updateTotalLoad"></b-form-input>
									</b-form-group>
								</b-col>
								<b-col class="pl-0">
									<b-form-group label="45W" label-cols="6" label-size="sm" label-align-sm="right">
										<b-form-input v-model="selectedItem.led_45w" @change="updateTotalLoad"></b-form-input>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row>
								<b-col class="pr-0">
									<b-form-group label="60W" label-cols="6" label-size="sm" label-align-sm="right">
										<b-form-input v-model="selectedItem.led_60w" @change="updateTotalLoad"></b-form-input>
									</b-form-group>
								</b-col>
								<b-col class="pl-0">
									<b-form-group label="70W" label-cols="6" label-size="sm" label-align-sm="right">
										<b-form-input v-model="selectedItem.led_70w" @change="updateTotalLoad"></b-form-input>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row>
								<b-col class="pr-0">
									<b-form-group label="75W" label-cols="6" label-size="sm" label-align-sm="right">
										<b-form-input v-model="selectedItem.led_75w" @change="updateTotalLoad"></b-form-input>
									</b-form-group>
								</b-col>
								<b-col class="pl-0">
									<b-form-group label="80W" label-cols="6" label-size="sm" label-align-sm="right">
										<b-form-input v-model="selectedItem.led_80w" @change="updateTotalLoad"></b-form-input>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row>
								<b-col class="pr-0">
									<b-form-group label="110W" label-cols="6" label-size="sm" label-align-sm="right">
										<b-form-input v-model="selectedItem.led_110w" @change="updateTotalLoad"></b-form-input>
									</b-form-group>
								</b-col>
								<b-col class="pl-0">
									<b-form-group label="130W" label-cols="6" label-size="sm" label-align-sm="right">
										<b-form-input v-model="selectedItem.led_130w" @change="updateTotalLoad"></b-form-input>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row>
								<b-col class="pr-0">
									<b-form-group label="140W" label-cols="6" label-size="sm" label-align-sm="right">
										<b-form-input v-model="selectedItem.led_140w" @change="updateTotalLoad"></b-form-input>
									</b-form-group>
								</b-col>
								<b-col class="pl-0">
									<b-form-group label="190W" label-cols="6" label-size="sm" label-align-sm="right">
										<b-form-input v-model="selectedItem.led_190w" @change="updateTotalLoad"></b-form-input>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row>
								<b-col class="pr-0">
									<b-form-group label="200W" label-cols="6" label-size="sm" label-align-sm="right">
										<b-form-input v-model="selectedItem.led_200w" @change="updateTotalLoad"></b-form-input>
									</b-form-group>
								</b-col>
								<b-col class="pl-0">
								</b-col>
							</b-row>
						</b-col>
					</b-row>
				</b-container>
				<form ref="form" @submit.stop.prevent="handleSubmit">
					
				</form>
				<template v-slot:modal-footer="{ ok, close }">
					<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
					<b-button size="sm" variant="success" @click="ok()">{{(selectedItem.id > 0)?'Update':'Submit'}}</b-button>
				</template>
			</b-modal>
		
		</b-container>
		<b-popover
			:target="popup_fittings_target"
			title="No of Fittings"
			ref="popover">
			<b-row>
				<b-col>LED 18 w : {{popup_fittings.led_18w}}</b-col>
			</b-row>
			<b-row>
				<b-col>LED 24 w : {{popup_fittings.led_24w}}</b-col>
			</b-row>
		</b-popover>
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: fixed; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
		<!--<search-sidebar></search-sidebar>-->
		
	</div>
	
</template>
<script>
import Header from "@/components/Header.vue";
//import Search from "@/components/Search.vue";
import { Line } from 'vue-chartjs';
export default {
	name: 'Devices',
	components: {
		"top-header": Header,
		//"search-sidebar": Search,
		"line-chart": Line,
	},
	beforeDestroy(){
		console.log("CLEAR INTERVAL DASHBOARD");
		clearInterval(this.interval);
		this.interval = '';
	},
    sockets: {
        connect() {
			if(this.interval != ''){
				clearInterval(this.interval);
			}

			this.is_connected = 'Connected';
			console.log('socket connected');
            this.$socket.emit('getdata', this.$route.params.ulbareacode);
        },
		datarecieved(data){
			console.log(JSON.stringify(data));
            this.records = data.devices;
            
			this.last_sync_time = data.time;//this.$moment(data.time).format('DD-MM-YYYY HH:mm:ss');

			this.initload();
		},
        disconnect() {
			this.is_connected = 'Disconnected';
			console.log('socket disconnected')
		}
    },
	mounted(){

		if(this.$socket.connected){
			console.log("CONNECTED AND LOADING DATA");
			if(this.interval != ''){
				clearInterval(this.interval);
			}
			this.$socket.emit('getdata', this.$route.params.ulbareacode);
		}
		
		var userinfo = this.$session.get('user_info');

		var hidden_fields = ['IMEI_NO', 'MOBILE_NO', 'LATITUDE', 'LONGITUDE', 'sys_meter_no'];

		
		if(userinfo.role != 1 && userinfo.role != 4 && userinfo.role != 10 && userinfo.role != 11){
			for(var i=this.fields.length-1; i>=0; i--){
				var field = this.fields[i];
				//console.log(i+' '+hidden_fields.indexOf(field.key)+' '+field.key);
				if(hidden_fields.indexOf(field.key) > -1){
					this.fields.splice(i,1);
				}
			}
		}
		
		/*if(this.$route.params.ulbareacode != 'up-meerut-meerut'){
			this.fields.splice(13,1);
		}*/
		this.$refs.livechart.renderChart({
			labels: ['January', 'February', 'March', 'April', 'May', 'June'],
			datasets: [
				{
					label: ' CCMS CONNECTED',
					borderColor: '#000099',
					backgroundColor: '#99d6ff',
					data: [8275, 5025, 6520, 3562, 5862, 6357],
					fill: false,
					lineTension: 0,
				},
				{
					label: ' CCMS ON',
					borderColor: '#009900',
					backgroundColor: '#00ff04',
					data: [7514, 9652, 4578, 3562, 8562, 1457],
					fill: false,
					lineTension: 0,
				},
				{
					label: ' LOAD',
					borderColor: '#f79800',
					backgroundColor: '#ffb642',
					data: [5236, 5025, 2365, 3562, 5862, 6357],
					fill: false,
					lineTension: 0,
				}
			]},{
			responsive: true
		});
		this.loadzones();
		//this.initload();
	},
	data() {
		var self = this;
		
		return{
			loading: true, 
			last_sync_time: '',
			interval: '',
			zoneOptions: [],
			networkfilter: 1,
			powerfilter: -1,
			current_led_load: 0,

			total_power_cut: 0,
			total_overload: 0,
			total_devices: 0,

			page_title: '',
			selectedUlb: self.$route.params.ulbareacode,
			ulbinfoUrl: self.$session.get('apiurl')+'api/getulbinfo',
			recordUrl: self.$session.get('apiurl')+'api/device-ulbs',
			insertUrl: self.$session.get('apiurl')+'api/device-insert',
			updateUrl: self.$session.get('apiurl')+'api/device-update',
			deleteUrl: self.$session.get('apiurl')+'api/device-delete',
			maintenanceUrl: self.$session.get('apiurl')+'api/device-maintenance',
			replaceUrl: self.$session.get('apiurl')+'api/replacepanel-insert',
			total_kwh: 0,
			device_on: 0,
			device_connected: 0,
            popup_fittings_target: '',
			total_load: 0,
			current_load: 0,
			total_lights: 0,
			total_light_on: 0,
			total_light_off: 0,
			total_signal_loss: 0,
			filteredrecords: [],
			info_powerfailure:0,
			records: [],
			fields: [
				{ key: 'FP_NO', label: 'F. No.', sortable: true, class: 'text-center' },
				{ key: 'LOCATION', label: 'Location', sortable: true, class: 'text-left',
					formatter: (value) => { 
						if(value != null){
							if(value.length > 30){
								return value.substring(0,30)+"...";
							}
							
						}
						return value;
					},
				},
				{ key: 'IMEI_NO', label: 'IMEI'},
				{ key: 'FITTINGS', label: 'Fittings', sortable: false,	sortByFormatted: true, filterByFormatted: true },
				{ key: 'TOTAL_LOAD', label: 'Physical Load', sortable: true, sortDirection: 'desc' , class: 'text-right',
					formatter: (value) => { 
						return (value/1000).toFixed(3);
					},
				},
				{ key: 'ACTUAL_LOAD', label: 'Actual Load', sortable: true, sortDirection: 'desc' , class: 'text-right',
					formatter: (value, key, item) => { 
						if(item.OUTPUT_STATUS == 0 && (parseInt(item.amp_r/1000) < self.$root.correction_amp || parseInt(item.amp_y/1000) < self.$root.correction_amp || parseInt(item.amp_b/1000) < self.$root.correction_amp)){
							value = 0;
						}
						return (value/100000).toFixed(3);
					},
				},
				{ key: 'supply', label: 'Power', class:"text-center"/*, 
					formatter: (value, key, item) => {
						var supply = 'ON';
						if(item.DATALENGTH == 59){
							supply = 'OFF';
						}
						return supply;
					},*/
				},
				{ key: 'DOOR_STATUS', label: 'Door Status' },
				{ key: 'LATITUDE', label: 'Latitude' },
				{ key: 'LONGITUDE', label: 'Longitude' },
				{ key: 'sys_meter_no', label: 'M.', sortable: true, 
					formatter: (value, key, item) => {
						console.log(value+' '+item.device_no);
						if(value == item.device_no){
							return 0;
						}
						return 1;
					},
				},
				{ key: 'overload', label: 'OL', sortable: true, sortDirection: 'desc' , class: 'text-right',
					formatter: (value, key, item) => {
						var fault = 0;
						if(item.meter_type === '1P'){
							fault = 100*((item.KW_R/1000) - (item.TOTAL_LOAD/1000))/(item.TOTAL_LOAD/1000) ;
						}else{
							fault = 100*((item.TOTAL_KW/100000) - (item.TOTAL_LOAD/1000))/(item.TOTAL_LOAD/1000);
						}
						return fault.toFixed(1);		
					},
				},
				{ key: 'underload', label: 'UL', class: 'text-right',
					formatter: (value, key, item) => {
						var fault = 0;
						if(item.meter_type === '1P'){
							fault = 100*((item.TOTAL_LOAD/1000) - (item.KW_R/1000))/(item.TOTAL_LOAD/1000) ;
						}else{
							fault = 100*((item.TOTAL_LOAD/1000) - (item.TOTAL_KW/100000))/(item.TOTAL_LOAD/1000);
						}
						if(fault>=99.9){
							fault = 100;
						}
						return fault.toFixed(1);		
					},
				},
				{ key: 'OUTPUT_STATUS', label: 'Output' , 
					formatter: (value) => {
						//if(value == 0){
						//	return 'OFF';
						//}
						return value;
					},
				},
				{ key: 'UPDATE_TIME', label: 'TimeStamp', 
					formatter: (value, key, item) => {
						/*if(item.data_fault == 1){
							return self.$moment(item.fault_time).format('DD-MM-YYYY HH:mm:ss');
						}*/
						if(item.update_time == "" || item.update_time == "00-00-0000 00:00"){
							return '-n/a-';
						}
						return self.$moment(item.update_time).format('DD-MM-YYYY HH:mm');
					},
				},
				{ key: 'connection_status', label: 'Network Status', sortable: true,
					formatter: (value, key, item) => {
						if(item.DATALENGTH == 0){
							return 3;
						}
						if(item.DATALENGTH != 59 && item.DATALENGTH != 210){
							return 2;
						}
						return value;
					}
				}
			],
			totalRows: 1,
			currentPage: 1,
			networkOptions: [{text:'All', value:-1}, {text:'Connected', value:1}, {text:'Disconnected', value:0}, {text:'Data Fault', value:2}, {text:'Pending', value:3}],
			powerOptions: [{text:'All', value:-1}, {text:'ON', value:1}, {text:'OFF', value:0}, {text:'Power Failure', value:2}],
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
			selectedItem: {},
			replaceItem: {},
			emptyItem: {
				id: 0,
				imei_no: '',
				zone_id: 0,
				state_id: 0,
				ulb_id: 0,
				feeder_pillar_no: '',
				ward_no: '',
				ccms_no: '',
				total_load: '',
				total_connection: 0,
				no_of_poles: 0,
				no_of_fittings: 0,
				location_lat: '',
				location_lng: '',
				meter_type: '3P',
				led_18w: 0,
				led_24w: 0,
				led_35w: 0,
				led_45w: 0,
				led_70w: 0,
				led_75w: 0,
				led_110w: 0,
				led_140w: 0,
				led_190w: 0,
				maintenance: 0
			},
			center: { lat: 0, lng: 0 },
			markers: [],
			center2: { lat: 0, lng: 0 },
			markers2: [],
			places: [],
			currentPlace: null,
			infoWindowPos: null,
			infoWindowOpen: false,
			currentMarkerIndex: null,
			zoneinfo: {},
			infoOptions: {
				content: '',
				pixelOffset: {
					width: 0,
					height: -35
				}
			},
			popup_fittings: {}
		};
	},
	methods: {
		reloaddata(){
			console.log("----- RELOADING DATA ----- ");
			this.$socket.emit('getdata', this.$route.params.ulbareacode);
		},
		showFittings(item, ref){
			this.popup_fittings_target = ref;
			this.popup_fittings = item.FITTINGS;
			this.$refs.popover.$emit('show')
		},
		onFilterDevices(){
			this.filteredrecords = this.filterDevices(this.records);
			this.totalRows = this.filteredrecords.length;
			this.currentPage = 1;
		},
		filterDevices(devices){
			var self = this;
			return devices.filter(function (d) {
				var valid = false;
				if(self.networkfilter < 0){
					//valid = true;
				}else if(self.networkfilter == 0){
					if(d.connection_status == 0 && d.DATALENGTH > 0){
						valid = true;
					}
				}else if(self.networkfilter == 1){
					if(d.connection_status == 1 && d.DATALENGTH > 0){
						valid = true;
					}
				}else if(self.networkfilter == 2){
					if(d.DATALENGTH != 59 && d.DATALENGTH != 210 && d.DATALENGTH != 0){
						valid = true;
					}
				}else if(self.networkfilter == 3){
					if(d.DATALENGTH == 0){
						valid = true;
					}
				}

				if(self.powerfilter < 0){
					//valid = true;
				}else if(self.powerfilter == 0){
					if(d.OUTPUT_STATUS == 0){
						valid = true;
					}
				}else if(self.powerfilter == 1){
					if(d.OUTPUT_STATUS == 1){
						valid = true;
					}
				}else if(self.powerfilter == 2){
					if(d.DATALENGTH == 59){
						valid = true;
					}
				}
				if(self.networkfilter < 0 && self.powerfilter< 0){
					valid = true;
				}
				if(valid){
					return d;
				}
			});
		},
		updateTotalLoad(){
			var total_load = 0;
			if(parseInt(this.selectedItem.led_18w) > 0){
				total_load += parseInt(this.selectedItem.led_18w) * 18;
			}
			if(parseInt(this.selectedItem.led_24w) > 0){
				total_load += parseInt(this.selectedItem.led_24w) * 24;
			}
			if(parseInt(this.selectedItem.led_35w) > 0){
				total_load += parseInt(this.selectedItem.led_35w) * 35;
			}
			if(parseInt(this.selectedItem.led_45w) > 0){
				total_load += parseInt(this.selectedItem.led_45w) * 45;
			}
			if(parseInt(this.selectedItem.led_60w) > 0){
				total_load += parseInt(this.selectedItem.led_60w) * 60;
			}
			if(parseInt(this.selectedItem.led_70w) > 0){
				total_load += parseInt(this.selectedItem.led_70w) * 70;
			}
			if(parseInt(this.selectedItem.led_75w) > 0){
				total_load += parseInt(this.selectedItem.led_75w) * 75;
			}
			if(parseInt(this.selectedItem.led_80w) > 0){
				total_load += parseInt(this.selectedItem.led_80w) * 80;
			}
			if(parseInt(this.selectedItem.led_110w) > 0){
				total_load += parseInt(this.selectedItem.led_110w) * 110;
			}
			if(parseInt(this.selectedItem.led_130w) > 0){
				total_load += parseInt(this.selectedItem.led_130w) * 130;
			}
			if(parseInt(this.selectedItem.led_140w) > 0){
				total_load += parseInt(this.selectedItem.led_140w) * 140;
			}
			if(parseInt(this.selectedItem.led_190w) > 0){
				total_load += parseInt(this.selectedItem.led_190w) * 190;
			}
			if(parseInt(this.selectedItem.led_200w) > 0){
				total_load += parseInt(this.selectedItem.led_200w) * 200;
			}
			this.selectedItem.total_load = total_load;
			
			this.selectedItem.no_of_fittings = parseInt(this.selectedItem.led_18w) + parseInt(this.selectedItem.led_24w) + parseInt(this.selectedItem.led_35w) + parseInt(this.selectedItem.led_45w) + parseInt(this.selectedItem.led_70w) + parseInt(this.selectedItem.led_75w) + parseInt(this.selectedItem.led_110w) + parseInt(this.selectedItem.led_140w) + parseInt(this.selectedItem.led_190w);
		},
		setMaintenance(val){
			var self = this;
			var maintenance_flag = -1;
			if(val.trigger == "maintenance_on"){
				maintenance_flag = 1;
			}
			else if(val.trigger == "maintenance_off"){
				maintenance_flag = 0;
			}

			if(maintenance_flag >= 0){
				var submitdata = new Object();
				submitdata.feeder_pillar_no = self.selectedItem.feeder_pillar_no;
				submitdata.maintenance = maintenance_flag;

				self.loading = true;
				//bvModalEvt.preventDefault();

				self.axios.post(self.maintenanceUrl, {
					accesskey: self.$session.get('access_key'),
					data: submitdata
				})
				.then(function (response) {
					if(response.data.error == 0 || response.data.error == '0'){
						self.$bvModal.hide('view-model');
						self.$bvToast.toast(response.data.message, {
							title: 'Status',
							toaster: 'b-toaster-bottom-right',
							autoHideDelay: 5000,
							variant: 'warning',
							solid: true,
							appendToast: true
						});
						//self.initload();
					}
					
				})
				.catch(function (error) {
					alert(error);
				});
			}
		},
		toogleMarkerInfoWindow(marker, index){
			this.infoWindowPos = marker.position;
			this.infoOptions.content = marker.infotext;
			if(this.currentMarkerIndex == index){
				this.infoWindowOpen = !this.infoWindowOpen;
			}else{
				this.infoWindowOpen = true;
				this.currentMarkerIndex = index;
			}
		},
		addMarker(lat, lng, infotext, iconurl) {
			const marker = {
				lat: lat,
				lng: lng
			};
			return { position: marker, infotext: infotext, icon: {url:iconurl,size: {width: 20, height: 28, f: 'px', b: 'px'}, scaledSize: {width: 20, height: 28, f: 'px', b: 'px',}} };
			//this.markers.push({ position: marker, infotext: infotext, icon: {url:iconurl} });
			//this.places.push(this.currentPlace);
			//this.center = marker;
			//this.currentPlace = null;
		},
		addMarker2(lat, lng, infotext, iconurl) {
			const marker = {
				lat: lat,
				lng: lng
			};
			//this.markers.push({ position: marker, infotext: infotext, icon: {url:iconurl,size: {width: 60, height: 90, f: 'px', b: 'px'}, scaledSize: {width: 30, height: 45, f: 'px', b: 'px',}} });
			this.markers.push({ position: marker, infotext: infotext, icon: {url:iconurl} });
			//this.places.push(this.currentPlace);
			this.center = marker;
			this.currentPlace = null;
		},
		filterZone: function (items) {
			var self = this;
			return items.filter(function (item) {
				if(item.parent ==0){
					return item.state  == self.selectedItem.state_id;
				}
			})
		},
		filterULB: function (items) {
			var self = this;
			return items.filter(function (item) {
				return item.parent == self.selectedItem.zone_id && item.parent > 0;
			})
		},
		showAddModal(){
			var self = this;
			this.selectedItem = Object.assign({}, this.emptyItem);
			this.zoneOptions.forEach(function(field){
				if(field.areacode == self.selectedUlb){
					self.selectedItem.state_id = field.state;
					if(field.parent > 0){
						self.selectedItem.zone_id = field.parent;
					}
					if(field.parent > 0){
						self.selectedItem.ulb_id = field.id;
					}
				}
			});
			this.$root.$emit('bv::show::modal', 'edit-model');
		},
		showUpdateModal(item, index, button) {
			this.selectedItem = Object.assign({}, item);
			this.$root.$emit('bv::show::modal', 'edit-model', button)
		},
		showViewModal(item, button){
			this.selectedItem = Object.assign({}, item);
			this.$root.$emit('bv::show::modal', 'view-model', button);
		},
		showReplaceModal(item, button){
			this.replaceItem = {
				replace_imei_no: item.imei_no,
				replace_meter_no: item.device_no,
				feeder_pillar_no: item.feeder_pillar_no,
				new_imei_no: '',
				new_meter_no: '',
				mobile_no: item.mobile_no,
				replace_time: '',
			};
			this.$root.$emit('bv::show::modal', 'replace-model', button);
		},
		showDeleteModal(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to delete device.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.deleteUrl, {
						accesskey: self.$session.get('access_key'),
						deleteid: item.id
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							//self.initload();
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		onReplaceDevice(bvModalEvt){
			var self = this;
			self.loading = true;
			bvModalEvt.preventDefault();
			
			self.axios.post(self.replaceUrl, {
				accesskey: self.$session.get('access_key'),
				data: self.replaceItem
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvModal.hide('replace-model');
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
					//self.initload();
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		},
		modalSubmit(bvModalEvt){
			var self = this;
			self.loading = true;
			bvModalEvt.preventDefault();
			var submitUrl = "";
			if(self.selectedItem.id == 0){
				submitUrl = self.insertUrl;
			}else{
				submitUrl = self.updateUrl;
			}
			
			self.axios.post(submitUrl, {
				accesskey: self.$session.get('access_key'),
				data: self.selectedItem
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvModal.hide('edit-model');
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
					//self.initload();
				}else{
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'danger',
						solid: true,
						appendToast: true
					});
				}
			})
			.catch(function (error) {
				alert(error);
			});
		},
		
		

		resetSelectedItem(){
			var self = this;
			self.selectedItem = Object.assign({}, self.emptyItem);
		},
		loadzones(){
			var self = this;
			
			self.axios.post(self.ulbinfoUrl, {
				ulbcode: self.$route.params.ulbareacode,
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.zoneinfo = response.data.result;
				}
			})
			.catch(function (error) {
				alert(error);
			});
		},
		initload(){
			var self = this;
			
            
					self.loading = false;
					self.totalRows = self.records.length;


					self.total_lights = 0;
					self.total_light_on = 0;
					self.total_light_off = 0;
					self.total_signal_loss = 0;

					self.total_power_cut = 0;
					self.total_overload = 0;

					self.current_load = 0;
					self.total_load = 0;

					self.total_kwh = 0;

					self.device_on = 0;
					self.device_connected = 0;
					var sno = 1;

				//	var meter_fault = 0;
					self.records.forEach(function(field){
						field.sno = sno++;
						field.supply = 0;
						if(field.DATALENGTH == 59){
							self.total_power_cut += 1;
							self.supply = 1;
						}
						
						
						if(field.ACTUAL_LOAD < 1000){
							field.ACTUAL_LOAD = 0;
						}

						self.total_lights += field.FITTINGS;
						
						self.total_load += parseInt(field.TOTAL_LOAD);

						if(field.ACTUAL_LOAD && field.ACTUAL_LOAD != 'NaN'){
							self.total_kwh += parseInt(field.ACTUAL_LOAD);
						}

						if(field.OUTPUT_STATUS != 0){
							if(field.TOTAL_KW && field.TOTAL_KW != 'NaN') self.current_load += parseInt(field.TOTAL_KW);
						}

						var curdatetime = self.$moment(self.last_sync_time); // i will replace this with server time by passing time in api
						var conn_status = 1;
						var dbdatetime = '';
						var duration = '';
						var minutes = '';
						
						
						if(field.UPDATE_TIME == "" || field.UPDATE_TIME == null || field.UPDATE_TIME == 'null' || field.UPDATE_TIME.length < 10){
							conn_status = 3;
							//console.log("::: "+field.update_time+' PENDING');
						}else{
							dbdatetime = self.$moment(field.UPDATE_TIME);
							
							if(curdatetime > dbdatetime){
								duration = self.$moment.duration(curdatetime.diff(dbdatetime));
							}else{
								duration = self.$moment.duration(dbdatetime.diff(curdatetime));
							}
							//console.log(duration.asMinutes());
							minutes = duration.asMinutes();
							var disconnection_time = self.$root.disconnection_time;
							if(minutes < disconnection_time){
								conn_status = 1;
							}else{
								conn_status = 0;
							}
						}
						
						field.connection_status = conn_status;
						if(conn_status == 1){
							self.device_connected += 1;
						}
						if(field.OUTPUT_STATUS == 1 && conn_status == 1){
							self.device_on += 1;
							self.total_light_on += field.FITTINGS;
						}
						if(field.OUTPUT_STATUS == 0 && conn_status == 1){
							self.total_light_off += field.FITTINGS;
						}
						if(conn_status == 0){
							self.total_signal_loss += field.FITTINGS;
						}


						if(field.METER_PHASE_TYPE === '1' || field.METER_PHASE_TYPE === 1){
							if((field.KW_R/1000) > (field.TOTAL_LOAD/1000) && conn_status == 1){
								self.total_overload += 1;
							}
						}else{
							if((field.TOTAL_KW/100000) > (field.TOTAL_LOAD/1000) && conn_status == 1){
								self.total_overload += 1;
							}
						}

						var fault = 0;
						if(field.METER_PHASE_TYPE === '1' || field.METER_PHASE_TYPE === 1){
							fault = 100*((field.KW_R/1000) - (field.TOTAL_LOAD/1000))/(field.TOTAL_LOAD/1000) ;
						}else{
							fault = 100*((field.TOTAL_KW/100000) - (field.TOTAL_LOAD/1000))/(field.TOTAL_LOAD/1000);
						}
						field.overload = fault.toFixed(1);
					});
					//console.log("METER FAULT "+meter_fault);
					self.filteredrecords = self.filterDevices(self.records);
					
					
					var min_lat = 100;
					var min_lng = 100;
					var max_lat = 0;
					var max_lng = 0;

					self.markers = [];
					self.markers2 = [];
					var geoloc = [];
					//if(self.markers.length == 0 || self.records.length != self.markers.length){
						for (var i = 0; i < self.records.length; i++) {
							var d = self.records[i];
							var actual_load = 0;
							if(parseInt(d.TOTAL_KW/100000) > 0.5){
								actual_load = (d.TOTAL_KW/100000).toFixed(3);
							}

							var msg = '<b>CCMS ID: '+d.FP_NO+'</b><br><b>Location</b> : '+d.LOCATION+'<br><b>Latitude :</b> '+d.LATITUDE+'<br><b>Longitude :</b> '+d.LONGITUDE+'<br><b>Total Lamps Connected :</b> '+d.FITTINGS+'<br><b>Actual Load KW :</b> '+actual_load+'<br><b>Last Updated Time :</b> '+self.$moment(d.UPDATE_TIME).format('DD-MM-YYYY HH:mm:ss');

							min_lat = Math.min(d.LATITUDE, min_lat);
							min_lng = Math.min(d.LONGITUDE, min_lng);

							max_lat = Math.max(d.LATITUDE, max_lat);
							max_lng = Math.max(d.LONGITUDE, max_lng);

							var blueurl = "https://www.fablurs.com/flag-blue.png";
							var redurl = "https://www.fablurs.com/flag-red.png";
							var greenurl = "https://www.fablurs.com/flag-green.png";
							var iconurl = blueurl;
							if(d.connection_status == 1){
								if(d.OUTPUT_STATUS == 1){
									iconurl = greenurl;
								}else{
									iconurl = redurl;
								}
							}
							
							geoloc.push(self.addMarker(self.records[i].LATITUDE, self.records[i].LONGITUDE, msg, iconurl));
						}
						self.markers = geoloc;
						self.center = { lat: min_lat + (max_lat - min_lat)/2, lng: min_lng + (max_lng - min_lng)/2 };
					//}
					if(self.interval != ''){
						clearInterval(self.interval);
					}
					self.interval = setTimeout(self.reloaddata, self.$root.reload_duration);
				
			
			//alert('login '+self.email+" "+self.password);
		},
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		downloadcsv(){
			var self = this;
			var header = new Array()
			self.fields.forEach(function(item){
				if(!item.extra){
					header.push(item.label);
				}
			});
			
			//var d = table.rows().data();
			var finalarr = new Array();
			finalarr.push(header);
			self.records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						if(field.key == 'total_load'){
							dataarr.push((row[field.key]/1000).toFixed(3));
						}else if(field.key == 'total_kw'){
							dataarr.push((row[field.key]/100000).toFixed(3));
						}else if(field.key == 'location'){
							dataarr.push(row[field.key].replace(","," "));
						}else{
							dataarr.push(row[field.key]);
						}
					}
				});
				finalarr.push(dataarr);
			});
			
			let csvContent = "data:text/csv;charset=utf-8," 
			+ finalarr.map(e => e.join(",")).join("\n");

			var encodedUri = encodeURI(csvContent);
			var link = document.createElement("a");
			link.setAttribute("href", encodedUri);
			link.setAttribute("download", "device_report.csv");
			document.body.appendChild(link); // Required for FF

			link.click();
		}
	}
}
</script>
<style>
html{
	min-height: 100%;
}
body{
	background-color: '#FFF' !important;
	background-image: none !important;
}
.table{
	font-size: small;
}
.table .btn{
	font-size: 12px;
	font-weight: 600;
}
.table td, .table th{
	vertical-align: middle;
}


.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}
.header-title{
	padding: 0.3rem 1.25rem;
}

.badge{
	font-size: 85%;
}

.text-sm{
	font-size: 13px;
}
.text-md{
	font-size: 16px;
}
.text-lg{
	font-size: 18px;
}
</style>